"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteGlobalVirtualCategory = void 0;
const routes_1 = require("../../routes");
const deleteGlobalVirtualCategory = (client) => async (params) => {
    const url = routes_1.ENDPOINTS.DELETE_GLOBAL_VIRTUAL_CATEGORY.applyParams(params);
    await client.delete(url);
};
exports.deleteGlobalVirtualCategory = deleteGlobalVirtualCategory;
